// src/pages/AppointmentPage.js
import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AppointmentForm from "../components/modals/AppointmentForm";

const AppointmentPage = () => {
    const [params] = useSearchParams();
    const sid = params.get("sid") || params.get("session_id") || "";
    const [open, setOpen] = useState(true);

    const sessionId = useMemo(() => sid.trim(), [sid]);

    useEffect(() => {
        // αν δεν υπάρχει sid, άνοιξε modal αλλά θα ζητήσει session_id από άλλο μηχανισμό
        setOpen(true);
    }, [sessionId]);

    return (
        <AppointmentForm
            open={open}
            onClose={() => setOpen(false)}
            sessionId={sessionId}
            onSuccess={() => setOpen(false)}
        />
    );
};

export default AppointmentPage;
